var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(!_vm.$route.meta.hideSidebar)?_c('core-drawer'):_vm._e(),_c('v-main',{staticClass:"overflow-hidden"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }